/* @flow */

import { compose } from 'ramda';
import classNames from 'classnames';
import * as React from 'react';
import withForwardRef from '@braindate/util/lib/react/hoc/withForwardRef';

import styles from './Card.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

type Props = {
  forwardedRef?: { current: null | HTMLElement },
  layoutClass?: string,
  rootLayoutClass?: string,
  children?: React.Node,
  isDisabled?: boolean,
  isFaded?: boolean,
  isGlowing?: boolean,
  isAccent?: boolean,
  withPadding?: boolean,
  disableChildrenMargin?: boolean,
  // Self passed
};

const useStyles = createUseThemeStyles(styles);

const Card = ({
  forwardedRef,
  layoutClass,
  rootLayoutClass,
  children,
  isFaded,
  isDisabled,
  isGlowing,
  isAccent,
  withPadding,
  disableChildrenMargin,
}: Props): React.Node => {
  const classes = useStyles({
    isAccent,
    withPadding,
    disableChildrenMargin,
  });

  // Classes

  const rootClasses = classNames(classes.root, {
    [classes['root-isFaded']]: isFaded,
    [classes['root-isDisabled']]: isDisabled,
    [classes['root-isGlowing']]: isGlowing,
  });

  return (
    <div
      className={classNames(rootClasses, rootLayoutClass)}
      ref={forwardedRef}
    >
      <div className={classNames(classes.wrapper, layoutClass)}>{children}</div>
    </div>
  );
};

export default compose(React.memo, withForwardRef)(Card);
